import { createStore } from "vuex";

export default createStore({
  state: {
    screenWidth: 0,
  },
  mutations: {
    SET_SCREEN_WIDTH(state, value) {
      state.screenWidth = value;
    },
  },
  actions: {
    setScreenWidth({ commit }, value) {
      commit('SET_SCREEN_WIDTH', value);
    },
  },
  getters: {
    getScreenWidth(state) {
      return state.screenWidth;
    },
  },
});
